<shared-header [icons]="icons"></shared-header>

<!-- Spheres parallax e icono de whatsapp en orden -->
<spheres-parallax [icons]="icons"></spheres-parallax>

<img class="whatsapp-icon" src="{{ icons.whatsapp }}" alt=""
  [ngStyle]=" {
          'width': '84px',
          'height': '84.287px',
          'position': 'fixed',
          'right': '48px',
          'bottom': '25px',
          'z-index': 1000,
          'cursor': 'pointer'
  }"
  (click)="openWhatsApp()">

<div class="bg-gray">
  <div class="max-container-1440">
    <div class="privacy">
      <div class="bg-image-1"></div>
      <div class="bg-image-2"></div>
      <div class="contenido-privacy" style="margin-top: 84px; margin-bottom: -32px;">
        <div class="head-privacy">
          <h1>AVISO DE PRIVACIDAD</h1>
          <div class="title" style="text-align:center; font-weight:900; font-size:18px; margin-top:8px;">
            CLIENTES Y/O PROSPECTOS Y/O USUARIOS FINALES<br>
            DRAM CÁPITAL S.A.P.I. DE C.V. S.O.F.O.M.E.N.R.
          </div>

          <p class="text">
            En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) vigente a partir del 21 de marzo del año 2025, hacemos de su conocimiento el presente Aviso de Privacidad, con el fin de informarle los términos y condiciones del tratamiento de sus datos personales. Estamos comprometidos con la protección de la privacidad de sus datos y hemos implementado medidas de seguridad administrativas, técnicas y físicas para resguardarlos conforme a la legislación aplicable.
          </p>
        </div>

        <div class="section">
          <p class="title">I. IDENTIDAD Y DOMICILIO DEL RESPONSABLE:</p>
          <ul>
            <li style="margin-bottom: 6px;"><b>NOMBRE COMERCIAL / MARCA:</b> DRAM CÁPITAL</li>
            <li style="margin-bottom: 6px;"><b>RAZÓN / DENOMINACIÓN SOCIAL:</b> DRAM CÁPITAL S.A.P.I. DE C.V. S.O.F.O.M.E.N.R.</li>
            <li style="margin-bottom: 6px;"><b>DOMICILIO:</b> Fray Luis de Palacio 377, Colonia Ladrón de Guevara, Código Postal 44560, Guadalajara, Jalisco.</li>
            <li style="margin-bottom: 6px;"><b>CORREO ELECTRÓNICO:</b> <a class="link" href="mailto:contacto@dram.capital"> contacto@dram.capital</a></li>
            <li style="margin-bottom: 6px;"><b>SITIO WEB OFICIAL:</b> <a class="link" href="https://dram.capital" target="_blank"> https://dram.capital</a></li>
            <li><b>FECHA ACTUALIZACIÓN DE AVISO:</b> 15 de abril de 2026</li>
          </ul>

        </div>

        <div class="section">
          <p class="title">II. DATOS PERSONALES QUE SERÁN RECABADOS (SOMETIDOS A TRATAMIENTO):</p>
          <p class="text" style="margin-bottom: 12px !important;">
            Para las finalidades señaladas en este aviso, recabaremos de usted datos personales que podrán incluir:
          </p>
          <ul>
            <li style="margin-bottom: 6px;"><b>DATOS DE IDENTIFICACIÓN:</b> Nombre, fecha de nacimiento, CURP, identificación oficial (INE o pasaporte).</li>
            <li style="margin-bottom: 6px;"><b>DATOS DE CONTACTO:</b> Teléfono, correo electrónico, y/o domicilio.</li>
            <li style="margin-bottom: 6px;"><b>DATOS DE REPRESENTACIÓN:</b> Actividad profesional o comercial, empleo actual y/o facultades notariales, en su caso.</li>
            <li style="margin-bottom: 6px;"><b>DATOS PATRIMONIALES:</b> Información de inmuebles ofrecidos en garantía hipotecaria, escritura pública, avaluó, certificado de libertad de gravamen.</li>
            <li style="margin-bottom: 6px;"><b>DATOS FINANCIEROS Y BANCARIOS:</b> Número de cuenta, CLABE interbancaria, institución bancaria, ingresos, historial crediticio, solo si son necesarios para pagos, cumplimiento de obligaciones contractuales, análisis de solicitudes de servicios y/o pago a crédito.</li>
            <li style="margin-bottom: 6px;"><b>DATOS FISCALES:</b> RFC, constancia fiscal, comprobantes fiscales, régimen fiscal y/u opinión de cumplimiento.</li>
            <li style="margin-bottom: 12px;"><b>DATOS SENSIBLES:</b> Datos biométricos, limitados a reconocimiento facial, mediante imagen, fotografía, videograbación y/o huella dactilar.</li>
          </ul>
          <p class="text" style="font-size: 14px;">
            <b>*DATOS SENSIBLES:</b> Los datos biométricos únicamente serán tratados para verificar la identidad del titular. Su recabo requiere consentimiento expreso y por escrito del titular, conforme al artículo 9 de la LFPDPPP. En caso de no otorgar dicho consentimiento, no podremos prestar los servicios que requieren verificación de identidad.
            <br><br>
            Podemos recabar dicha información de manera personal o bien por cualquier medio impreso, electrónico, sonoro, visual o a través de cualquier otra tecnología. Asimismo, tiene la posibilidad de obtener y/o verificar los datos personales a través de terceros y de otras fuentes permitidas por la Ley, exclusivamente para las finalidades que se describen en el punto siguiente.
          </p>
        </div>

        <div class="section">
          <p class="title">III. FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES:</p>
          <p class="text" >
            Sus datos personales serán tratados para alguna de las siguientes finalidades, según corresponda a cada situación:
          </p>
          <div style="text-align: center; margin: 20px 0 0 0;">
            <p class="text" style="font-weight: bold;">Tipo</p>
          </div>
          <p class="text" style="font-weight: bold;">Finalidades (puede aplicar una o varias)</p>
          <div style="text-align: center; margin: 20px 0 0 0;">
            <p class="text" style="margin-bottom: 8px; text-decoration: underline; font-weight: bold;">Finalidades primarias</p>
          </div>
            <ol class="letras-paren">
              <li>Identificación y verificación del titular.</li>
              <li>Evaluar el inicio de una relación comercial y/o de prestación de servicios.</li>
              <li>Prestación de servicios y/o compraventa de productos.</li>
              <li>Cumplimiento de obligaciones.</li>
              <li>Administración y gestión interna de servicios y operaciones.</li>
              <li>Atención a solicitudes.</li>
              <li>Gestión de pagos, facturación y cobranza.</li>
              <li>Firma de contrato con el titular.</li>
              <li>Para contactarlo ante alguna emergencia que requiera de su autorización o información.</li>
              <li>Brindarle los resultados del servicio realizado.</li>
              <li>Enviarle cotización de los servicios solicitados.</li>
              <li>Emitir la factura por la prestación de servicios.</li>
              <li>Acceso a nuestro sistema, en su caso.</li>
              <li>Registro, control de acceso y videovigilancia para fines de seguridad en nuestras instalaciones.</li>
            </ol>
          <div style="text-align: center; margin: 20px 0 0 0;">
            <p class="text" style="margin: 16px 0 8px 0; text-decoration: underline; font-weight: bold;">Finalidades secundarias</p>
          </div>
          <ol class="letras-paren">
            <li>Fines estadísticos y de análisis interno.</li>
            <li>Encuestas de satisfacción y mejora del servicio.</li>
            <li>Soporte técnico.</li>
          </ol>
          <p class="text">
            <span style="font-weight: bold;">Los datos personales recabados de prospectos de clientes o proveedores serán utilizados exclusivamente para fines de análisis, contacto y eventual formalización de una relación comercial o de prestación de servicios.</span>
            <br><br>
            No daremos a sus datos personales un uso distinto a las finalidades antes descritas. En caso de que en un futuro requiramos usar sus datos personales para alguna finalidad secundaria no compatible con las aquí establecidas, le informaremos oportunamente y, de ser necesario, solicitaremos su consentimiento previo.
          </p>
        </div>

        <div class="section">
          <p class="title">IV. OPCIONES Y MEDIOS PARA LIMITAR EL USO O DIVULGACIÓN DE LOS DATOS:</p>
          <p class="text" style="margin-bottom: 12px !important;">
            De acuerdo con la LFPDPPP, usted tiene en todo momento el derecho de ejercer los denominados Derechos ARCO:
          </p>
          <ul>
            <li style="margin-bottom: 6px;"><b>ACCESO:</b> Conocer qué datos personales tenemos de usted, para qué los usamos y las condiciones del tratamiento.</li>
            <li style="margin-bottom: 6px;"><b>RECTIFICACIÓN:</b> Solicitar la corrección de sus datos cuando sean inexactos, incompletos o no estén actualizados.</li>
            <li style="margin-bottom: 6px;"><b>CANCELACIÓN:</b> Solicitar la eliminación de sus datos de nuestros archivos y sistemas. La solicitud inicia un periodo de bloqueo, tras el cual se procede a la supresión; una vez cancelado, le informaremos.</li>
            <li style="margin-bottom: 6px;"><b>OPOSICIÓN:</b> Oponerse al tratamiento de sus datos por causa legítima o cuando el tratamiento produzca efectos adversos en sus derechos e intereses.</li>
          </ul>
          <p class="text">
            Asimismo, puede revocar su consentimiento para el tratamiento de sus datos en cualquier momento, ya sea respecto a la totalidad de sus datos o solo para alguna finalidad en particular.
            <br><br>
            Es importante mencionar que no en todos los casos podremos atender de manera absoluta su solicitud, ya que por disposiciones legales podríamos requerir seguir conservando ciertos datos por un periodo determinado (por ejemplo, para cumplir obligaciones fiscales) o porque los datos sean necesarios para continuar prestándole el servicio contratado. No obstante, siempre podrá ejercer sus derechos ARCO para limitar el uso o divulgación de su información personal.
            <br><br>
            Cuando los datos personales hubiesen sido transmitidos con anterioridad a la fecha de rectificación o cancelación, haremos del conocimiento de dichos terceros de su solicitud para que procedan de igual forma. No tendremos la obligación de cancelar datos personales cuando se presenten los supuestos del artículo 25 de la LFPDPPP.
          </p>
        </div>

        <div class="section">
          <p class="title">V. MECANISMOS PARA EL EJERCICIO DE DERECHOS ARCO:</p>
          <p class="text" style="margin-bottom: 12px !important;">
            Para ejercer cualquiera de estos derechos o revocar su consentimiento, envíenos una solicitud al correo indicado en el apartado I, la cual deberá contener:
          </p>
          <ol class="numeros-bold">
            <li>Nombre completo del titular y, en su caso, de su representante legal.</li>
            <li>Domicilio o medio electrónico para recibir notificaciones.</li>
            <li>Copia de identificación oficial del titular y/o representante legal.</li>
            <li>Descripción clara y precisa de los datos personales respecto de los que se busca ejercer el derecho.</li>
            <li>Cualquier documento o información adicional que facilite la localización de sus datos en nuestras bases.</li>
            <li>En el caso de rectificación, deberá acompañarse con la documentación que acredite la corrección solicitada.</li>
          </ol>
          <div class="text" style="margin-top:16px;">
            <b>Plazos de atención:</b>
            <ul>
              <li style="margin: 6px 0; "><b>Acuse de recibo de la solicitud:</b> 5 días hábiles</li>
              <li style="margin-bottom: 6px;"><b>Notificación de subsanación (si aplica):</b> 5 días hábiles desde la recepción</li>
              <li style="margin-bottom: 6px;"><b>Plazo para subsanar la solicitud:</b> 10 días hábiles desde la notificación</li>
              <li style="margin-bottom: 6px;"><b>Respuesta definitiva:</b> 20 días hábiles desde la recepción completa</li>
              <li style="margin: 6px 0 12px 0;"><b>Ejecución de la medida (si es procedente):</b> 15 días hábiles posteriores a la respuesta</li>
            </ul>
            Los plazos indicados podrán ser ampliados en términos de la ley, si existiera una justificación. El responsable entregará la información o resolverá lo solicitado mediante el correo electrónico que usted haya indicado para tal efecto.
          </div>
        </div>

        <div class="section">
          <p class="title">VI. CAMBIOS AL AVISO DE PRIVACIDAD:</p>
          <div style="margin: 15px 0;">
            <p class="text">
              El presente aviso podrá ser modificado o actualizado en el futuro para cumplir con cambios legislativos, políticas internas o nuevos requerimientos. Cualquier cambio sustancial le será notificado mediante:
            </p>
          </div>
          <ul>
            <li style="margin-bottom: 6px;">Mensaje al correo electrónico que nos haya proporcionado.</li>
            <li style="margin-bottom: 6px;">Publicación en nuestra página web oficial en la sección de Aviso de Privacidad.</li>
            <li style="margin-bottom: 12px;">De forma visible en nuestras instalaciones físicas.</li>
          </ul>
          <div>
            <span class="text">
              Le recomendamos revisar periódicamente nuestro sitio web para informarse de cualquier cambio.
            </span>
          </div>
        </div>

        <div class="section">
          <p class="title">VII. TRANSFERENCIA DE DATOS PERSONALES:</p>
          <p class="text" style="margin-bottom: 12px !important;">
            Sus datos personales podrán ser transferidos a terceros, previo al inicio de una relación comercial o durante la misma, para su validación o para cumplimiento de obligaciones contractuales o legales. En ese sentido, podremos transferir sus datos a:
          </p>
          <ul style="margin-bottom: 12px;">
            <li><b style="text-decoration: underline;">DESPACHO JURÍDICO:</b> para revisión de términos legales de la relación comercial, validación de documentos e información del titular, elaboración o revisión de contratos y cualquier otro documento vinculado a la relación.</li>
            <li><b style="text-decoration: underline; ">DESPACHO CONTABLE:</b> para validar información proporcionada, gestionar procesos de facturación, cumplimiento de obligaciones fiscales y contables, o cualquier actividad directamente vinculada con la relación contractual.</li>
          </ul>
          <p class="text">
            Estas transferencias se realizarán únicamente cuando sean necesarias para el cumplimiento de las finalidades previstas en este aviso, observando en todo momento los principios de licitud, finalidad, lealtad, consentimiento, calidad, proporcionalidad, información y responsabilidad en el tratamiento de datos personales.
            <br><br>
            Nos aseguraremos de que dichos terceros adopten las medidas de seguridad, confidencialidad y protección necesarias para salvaguardar sus datos conforme a la ley.
          </p>
        </div>

        <div class="section">
          <p class="title">VIII. USO DE COOKIES Y TECNOLOGÍAS DE SEGUIMIENTO:</p>
          <p class="text">
            La Aplicación y/o el Sitio Web de DRAM CÁPITAL podrán hacer uso de Cookies y tecnologías similares. Las Cookies son archivos de datos que se almacenan en el dispositivo del Usuario con el fin de reconocerlo en visitas posteriores, personalizar su experiencia y mejorar el funcionamiento de la Plataforma. En ningún caso las Cookies dañarán el hardware, software o información del Usuario, ni permitirán el acceso no autorizado a sus datos personales.
          </p>
          <div style="margin: 8px 0;">
            <p class="text" style="font-weight: bold;">
              Tipos de cookies que utilizamos:
            </p>
          </div>
          <ul style="margin-bottom: 12px;">
            <li><b>Cookies propias y de sesión:</b> Se eliminan al cerrar el navegador. Se usan para mantener la sesión activa del Usuario.</li>
            <li><b>Cookies persistentes:</b> Permanecen en el dispositivo por un periodo determinado. Permiten reconocer al Usuario en visitas posteriores y recordar sus preferencias.</li>
            <li><b>Cookies analíticas:</b> Permiten conocer el comportamiento de navegación dentro de la Plataforma con fines estadísticos y de mejora del servicio, sin identificar al Usuario de forma individual.</li>
            <li><b>Web Beacons:</b> La Aplicación también puede contener Web Beacons, que son pequeños archivos gráficos electrónicos que trabajan en conjunto con las Cookies para identificar qué secciones de la Plataforma son de mayor interés para los Usuarios. Si las Cookies son desactivadas, los Web Beacons podrán seguir detectando visitas anónimas, pero la información generada no podrá asociarse con ningún dato personal identificable.</li>
          </ul>
          <p class="text">
            El Usuario podrá configurar su navegador o sistema operativo para rechazar o deshabilitar las Cookies en cualquier momento. Sin embargo, DRAM CÁPITAL no se responsabiliza por posibles afectaciones al funcionamiento del Sitio Web y/o Plataforma derivadas de dicha desactivación. Para revocar el consentimiento otorgado al uso de Cookies, el Usuario podrá hacerlo mediante los mecanismos descritos en el apartado IV del presente Aviso.
          </p>
        </div>

        <div class="section">
          <p class="title">IX. AUTORIDAD COMPETENTE:</p>
          <p class="text">
            A partir del 21 de marzo de 2025, la autoridad encargada de la supervisión, vigilancia y regulación en materia de protección de datos personales es la Secretaría Anticorrupción y Buen Gobierno (antes INAI), dependiente del Poder Ejecutivo Federal.
            <br><br>
            Si usted considera que su derecho a la protección de datos personales ha sido lesionado por alguna conducta de nuestra parte, o presume que existe alguna violación a las disposiciones de la LFPDPPP, podrá interponer la queja o denuncia correspondiente ante dicha Secretaría.
          </p>
          <div style="margin: 15px 0;">
            <ul>
              <li><b>AUTORIDAD:</b> Secretaría Anticorrupción y Buen Gobierno</li>
              <li><b>SITIO WEB:</b> <a class="link" href="https://www.gob.mx/buengobierno" target="_blank"> https://www.gob.mx/buengobierno</a></li>
              <li><b>FUNDAMENTO LEGAL:</b> Artículo 38 de la LFPDPPP</li>
            </ul>
          </div>
        </div>

        <div class="section">
          <p class="text" style="margin-top: 24px;">
            <b>SI USTED NO ESTÁ DE ACUERDO CON ESTE AVISO DE PRIVACIDAD, NO UTILICE NUESTROS SERVICIOS NI PROPORCIONE SUS DATOS PERSONALES.</b>
            <br><br>
            Para cualquier duda o aclaración, contáctenos en: <a class="link" href="mailto:contacto@dram.capital">contacto@dram.capital</a>
            <br><br>
            LEÍDO el presente Aviso de Privacidad y enterado de su contenido y alcance, al proporcionar sus datos personales debido a la utilización de la Aplicación, usted consiente que sus datos personales sean tratados conforme a los términos y condiciones aquí establecidas.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<dram-footer></dram-footer>
